import { useDispatch, useSelector } from 'react-redux'
import { React } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from '@mui/material'
import EditAlert from 'asserts/images/EditAlert.svg'
import DeleteAlert from 'asserts/images/DeleteAlert.svg'
import { useEffect, useState } from 'react'
import './PrevTabs.css'
import { getLeaderboardTabs } from 'store/action/leaderboardTabs'
import { deleteLeaderboardtab } from 'store/action/deleteLeaderboardtab'
import Confirmation from 'Components/ReusableComponents.js/ConfirmationPopup/Confirmation'

let tableHeaders = [
  {
    id: 0,
    title: 'Tab Name',
    dataKey: 'tabName',
  },
  {
    id: 1,
    title: 'Action',
    dataKey: '',
  },
]

const PreviouslyAdded = ({ setSelectedTab, setEditData }) => {
  const dispatch = useDispatch()
  const leaderboardTabs = useSelector((state) => state?.leaderboardtabs?.data)
  const isLoading = useSelector((state) => state?.leaderboardtabs?.loading)
  const tabsData = leaderboardTabs?.tabs.filter((item) => item.hasOwnProperty('csvPath')) || []
  const [showConfirm, setShowConfirm] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)

  useEffect(() => {
    dispatch(getLeaderboardTabs())
  }, [dispatch])

  const handleEdit = (item) => {
    setEditData(item)
    setSelectedTab(0)
  }

  const handleDelete = async (tabId) => {
    try {
      await dispatch(deleteLeaderboardtab(tabId))
    } catch (error) {
      console.error('Delete failed:', error)
    }
  }

  const handleConfirmCancel = () => {
    if (itemToDelete?.id) {
      handleDelete(itemToDelete.id)
    }
    setShowConfirm(false)
    setItemToDelete(null)
  }

  const displayData = (item, id) => {
    switch (id) {
      case 0:
        return (
          <Typography variant="p" className="body-type-typography">
            {item.tabName}
          </Typography>
        )

      default:
        return (
          <Box className="d-flex mr-3" style={{ marginRight: '126px !important' }}>
            <img src={EditAlert} alt="Edit Alert" className="p-2 cursorshow" onClick={() => handleEdit(item)} />
            <img
              src={DeleteAlert}
              alt="Delete Alert"
              className="p-2 cursorshow"
              onClick={() => {
                setItemToDelete(item)
                setShowConfirm(true)
              }}
            />
          </Box>
        )
    }
  }

  return (
    <>
      {showConfirm && itemToDelete && (
        <Confirmation
          text={`Are you sure you want to delete "${itemToDelete.tabName}" tab?`}
          affirm="Confirm"
          cancel="Cancel"
          affirmFunction={handleConfirmCancel}
          cancelFunction={() => {
            setShowConfirm(false)
            setItemToDelete(null)
          }}
        />
      )}

      <TableContainer className="table-container my-3 prev_tabs_parent">
        <Table className="tableheader">
          <TableHead>
            <TableRow>
              {tableHeaders?.map((item, index) => (
                <TableCell
                  key={index}
                  className={`alerts-tablecellstyle ${item.dataKey === 'tabName' ? 'alert-type-header' : ''} `}
                >
                  {item.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        </Table>
        <Box
          className="customscroll table-body-box-container"
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <Table>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell
                    colSpan={tableHeaders.length}
                    align="center"
                    sx={{
                      height: '135px',
                      width: '100%',
                      backgroundColor: '#F5F6FA',
                    }}
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : tabsData.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={tableHeaders.length}
                    align="center"
                    sx={{
                      height: '135px',
                      width: '100%',
                      backgroundColor: '#F5F6FA',
                      color: '#505050',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: '24px',
                        fontFamily: 'HK Grotesk',
                        color: '#2c2c2c',
                      }}
                    >
                      Nothing to showcase yet!
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                tabsData.map((item, index) => (
                  <TableRow key={index} className="body-row">
                    {tableHeaders.map((data, idx) => (
                      <TableCell key={idx} className="table-body-cell">
                        {displayData(item, data.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>
    </>
  )
}

export default PreviouslyAdded
